<template>
    <div class="bg-red-500 ">
        <slot />
    </div>
</template>
<script lang="ts">
import { defineComponent } from "vue"


export default defineComponent({})
</script>
